import { safeRemoveItem, safeSetItem } from "@/utils/safeStorage";

import { withMixpanel } from "../events/mixpanelClient";

// Daily-credit allowance A/B test (DEV-3413) — 3 credits/day vs 5. The backend
// buckets and enforces; we report the arm as a super property plus the
// localStorage mirror that feeds x-mp-test-groups.
//
// CLOSED (backend ADR 0027): nothing buckets an account into it any more, so
// the cohorts are read-only on the accounts that already carry them. Still
// enforced, though — those users keep their 3 or 5 a day — which is why we
// keep reporting the arm.
//
// The arm is read from experimentGroups on /profile, not buckets.daily.limit
// on /credits: an unenrolled account's limit is 3, indistinguishable from the
// low arm's.
//
// Both events are gone: daily_limits_test_exposed was replaced by the
// backend's signup_bonus_exhausted, and daily_limits_test_assigned went with
// the close, since there are no new enrollments left to announce.

// localStorage key and Mixpanel property name, one and the same.
export const DAILY_CREDIT_TEST_GROUP_ID = "daily_credit_ab";
export const DAILY_CREDIT_TEST_MP_PROPERTY = DAILY_CREDIT_TEST_GROUP_ID;

// `daily-1` is the pre-DEV-3830 low-arm name; the backend re-buckets it to
// daily-3, and it is mapped here so the arm survives until it does.
const GROUP_BY_COHORT: Record<string, string> = {
  "daily-1": "daily-3",
  "daily-3": "daily-3",
  "daily-5": "daily-5",
};

// The arm a profile's experiment groups put the user in, or null.
export const dailyCreditGroupFromProfile = (
  experimentGroups: readonly string[] | undefined,
): string | null => {
  for (const cohort of experimentGroups ?? []) {
    const group = GROUP_BY_COHORT[cohort];
    if (group) return group;
  }
  return null;
};

// Mirrors the arm from a fresh /profile. The super property is re-registered
// every call because mixpanel.reset() on logout wipes it.
export const reportDailyCreditTestGroup = (
  experimentGroups: readonly string[] | undefined,
): void => {
  const group = dailyCreditGroupFromProfile(experimentGroups);
  if (!group) return;

  withMixpanel((mp) => mp.register({ [DAILY_CREDIT_TEST_MP_PROPERTY]: group }));
  safeSetItem(DAILY_CREDIT_TEST_GROUP_ID, group);
};

// Drops the mirror when a session ends, or the next account ships this user's
// arm.
export const clearDailyCreditTestGroup = (): void =>
  safeRemoveItem(DAILY_CREDIT_TEST_GROUP_ID);
